"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiUsersClient = void 0;
const UserConverter_1 = require("../model/UserConverter");
const expandUrlTemplate_1 = __importDefault(require("../../common/utils/expandUrlTemplate"));
const ApiSubClient_1 = require("../../common/client/ApiSubClient");
class ApiUsersClient extends ApiSubClient_1.ApiSubClient {
    isUserActive(id) {
        const isUserActiveLink = this.getLinkOrThrow('isUserActive');
        return this.axios
            .get((0, expandUrlTemplate_1.default)(isUserActiveLink.href, { id }))
            .then((response) => response.status === 200)
            .catch((_) => false);
    }
    getCurrentUser() {
        const currentUser = this.getLinkOrThrow('currentUser');
        return this.axios
            .get(currentUser.href)
            .then((response) => UserConverter_1.UserConverter.convert(response.data));
    }
    createUser(createUserRequest) {
        const createUser = this.getLinkOrThrow('createUser');
        return this.axios
            .post(createUser.href, createUserRequest)
            .then((response) => UserConverter_1.UserConverter.convert(response.data));
    }
    createTrialUser(createTrialUserRequest) {
        const createUser = this.getLinkOrThrow('createUser');
        return this.axios
            .post(createUser.href, createTrialUserRequest)
            .then((response) => UserConverter_1.UserConverter.convert(response.data));
    }
    createClassroomUser(createClassroomUserRequest) {
        const createUser = this.getLinkOrThrow('createUser');
        return this.axios
            .post(createUser.href, createClassroomUserRequest)
            .then((response) => UserConverter_1.UserConverter.convert(response.data));
    }
    createDistrictUser(createDistrictUserRequest) {
        const createUser = this.getLinkOrThrow('createUser');
        return this.axios
            .post(createUser.href, createDistrictUserRequest)
            .then((response) => UserConverter_1.UserConverter.convert(response.data));
    }
    deleteUser(id) {
        const deleteUser = this.getLinkOrThrow('deleteUser');
        return this.axios.delete((0, expandUrlTemplate_1.default)(deleteUser.href, { id }));
    }
    updateUser(id, updateUserRequest) {
        const updateUser = this.getLinkOrThrow('updateUser');
        return this.axios
            .put((0, expandUrlTemplate_1.default)(updateUser.href, { id }), updateUserRequest)
            .then((response) => response.status === 200);
    }
    resendActivationEmail(user) {
        const originalLink = user.links?.sendActivationEmail?.getOriginalLink();
        if (!originalLink)
            throw new Error('Activation link is missing on user');
        return this.axios
            .post(originalLink, {})
            .then((response) => response.status === 204)
            .catch((_) => false);
    }
    updateSelf(user, updateUserRequest) {
        const originalLink = user.links?.self?.getOriginalLink();
        if (!originalLink)
            throw new Error('Self link is missing on user');
        return this.axios
            .put(originalLink, updateUserRequest)
            .then((response) => UserConverter_1.UserConverter.convert(response.data));
    }
}
exports.ApiUsersClient = ApiUsersClient;
//# sourceMappingURL=ApiUsersClient.js.map